import { proxyCustomElement, HTMLElement, createEvent, h } from '@stencil/core/internal/client';
import { d as defineCustomElement$5 } from './flex.js';
import { d as defineCustomElement$4 } from './icon.js';
import { d as defineCustomElement$3 } from './radio.js';
import { d as defineCustomElement$2 } from './text.js';

const RadioGroup = /*@__PURE__*/ proxyCustomElement(class RadioGroup extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.skpRadioCheck = createEvent(this, "skpRadioCheck", 7);
    this.direction = 'column';
    this.disabled = false;
    this.gap = 3;
    this.name = `radio-group-${Math.ceil(Math.random() * Date.now())}`;
    this.options = undefined;
    this.size = undefined;
    this.value = undefined;
  }
  onSkpCheck(e) {
    this.skpRadioCheck.emit(e.detail);
    this.value = e.detail;
  }
  handleKeyDown(e) {
    var _a, _b;
    if (this.disabled)
      return;
    if (['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight'].includes(e.code)) {
      e.preventDefault();
      const currentRadio = e.target.parentElement;
      const values = this.options.filter(({ disabled }) => !disabled).map(({ value }) => value);
      const currentIndex = values.findIndex((value) => value === currentRadio.value);
      const nextValue = e.code === 'ArrowDown' || e.code === 'ArrowRight'
        ? values[currentIndex + 1] || values[0]
        : values[currentIndex - 1] || values[values.length - 1];
      (_b = (_a = currentRadio.parentElement.querySelector(`[value="${nextValue}"]`)) === null || _a === void 0 ? void 0 : _a.querySelector('label')) === null || _b === void 0 ? void 0 : _b.focus();
    }
  }
  render() {
    return (h("skp-flex", { flexDirection: this.direction, justifyContent: 'flex-start', gap: this.gap, onKeyDown: this.handleKeyDown.bind(this) }, this.options.map((option) => (h("skp-radio", Object.assign({}, option, { checked: this.value === option.value, disabled: this.disabled || option.disabled, name: this.name, size: this.size || option.size }))))));
  }
}, [0, "skp-radio-group", {
    "direction": [1],
    "disabled": [4],
    "gap": [2],
    "name": [1],
    "options": [16],
    "size": [1],
    "value": [1025]
  }, [[0, "skpCheck", "onSkpCheck"]]]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["skp-radio-group", "skp-flex", "skp-icon", "skp-radio", "skp-text"];
  components.forEach(tagName => { switch (tagName) {
    case "skp-radio-group":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, RadioGroup);
      }
      break;
    case "skp-flex":
      if (!customElements.get(tagName)) {
        defineCustomElement$5();
      }
      break;
    case "skp-icon":
      if (!customElements.get(tagName)) {
        defineCustomElement$4();
      }
      break;
    case "skp-radio":
      if (!customElements.get(tagName)) {
        defineCustomElement$3();
      }
      break;
    case "skp-text":
      if (!customElements.get(tagName)) {
        defineCustomElement$2();
      }
      break;
  } });
}

const SkpRadioGroup = RadioGroup;
const defineCustomElement = defineCustomElement$1;

export { SkpRadioGroup, defineCustomElement };
